import { defineComponent as t, openBlock as l, createElementBlock as i, normalizeClass as a, pushScopeId as c, popScopeId as _, createElementVNode as o } from "vue";
const n = (e) => (c("data-v-4a3ac9e3"), e = e(), _(), e), d = /* @__PURE__ */ n(() => /* @__PURE__ */ o("div", null, null, -1)), p = /* @__PURE__ */ n(() => /* @__PURE__ */ o("div", null, null, -1)), r = /* @__PURE__ */ n(() => /* @__PURE__ */ o("div", null, null, -1)), u = /* @__PURE__ */ n(() => /* @__PURE__ */ o("div", null, null, -1)), m = [
  d,
  p,
  r,
  u
], f = /* @__PURE__ */ t({
  name: "processing-animation",
  __name: "processing-animation",
  setup(e) {
    return (s, h) => (l(), i("div", {
      class: a(s.$options.name),
      role: "progressbar"
    }, m, 2));
  }
});
export {
  f as default
};
//# sourceMappingURL=processing-animation.vue2.js.map
